import React from 'react';
import { Link } from "react-router-dom";

function LogoTop(){
    return (
        <div className="before-logintop">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-4 pe-0">
                        <img src="../../assets/images/logo.svg" alt="logo"/>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LogoTop;